import { ApplicationAvailabilityContext, validateAvailability } from 'omni-package-react-core';
import { FC, useContext, useEffect } from 'react';

export const AvailabilityConfig = {
  company: '0' as '0' | '6',
  experience: 'CLIENT' as 'CLIENT' | 'ADVISOR' | 'EMPLOYEE',
  group: 'EXT2',
};

export interface AvailabilityManagerProps { }

const AvailabilityManager: FC<AvailabilityManagerProps> = () => {
  const availabilityCtx = useContext(ApplicationAvailabilityContext);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/no-unsafe-argument
    validateAvailability(AvailabilityConfig.group, AvailabilityConfig.company, AvailabilityConfig.experience, true)
      .then((availability) => availabilityCtx.saveAvailability(availability));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AvailabilityManager;
